// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2JHYa","label":"Labeled_label__20OXv","divider":"Labeled_divider__10-6C"};